/* eslint-disable no-loop-func */
import { createContext, useRef, useState, useContext } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "./AuthProvider";
// import { isPossiblePhoneNumber } from "react-phone-number-input";
import { registrationForms } from "../data/registrationForms";
import { regularData } from "../data/regularData";

const RegistrationContext = createContext({});

export const RegistrationProvider = ({ children }) => {
	let curr = new Date();
	curr.setDate(curr.getDate());
	let date = curr.toISOString().substring(0, 10);
	const inputStart = useRef();
	const emailInputRef = useRef();
	const { auth } = useContext(AuthContext);

	const [page, setPage] = useState(0);

	const [data, setData] = useState({
		canGoNext: true,
		isNdcMember: false,
		isOutsideGhana: false,

		membershipNdcMembership: "",
		membershipNdcMembershipNumber: "",
		membershipVoterIdNumber: "",

		personalProfilePicture: "",
		personalTitle: "",
		personalLastname: "",
		personalFirstname: "",
		personalMiddleName: "",
		personalDateOfBirth: date,
		personalGender: "",
		personalMaritalStatus: "",

		contactMobileNumber: "",
		contactEmail: "",

		regionsRegionCode:"",
		regionsRegionName:"",
		regionsConstituencyCode:"",
		regionsConstituencyName:"",
		regionsBranchCode:"",
		regionsBranchName: "",
		regionsRecommendedBy: "",
		regionsRegionalPresident: "",
		regionsRegionalPresidentMobileNumber: "",
		regionsRegionalPresidentEmail: "",
		
		educationLastTertiaryInstitution:"",
		educationQualificationType:"",
		educationQualification:"",

		professionProfession: "",
		professionOccupation: "",
		professionEmploymentType: "",
		professionCurrentEmployment: "",

	});




	const handleMembershipStatus = (e) => {
		const name = e.target.name;
		const value = e.target.value;

		if (value === "YES") {
			setData((prevData) => ({
				...prevData,
				[name]: value,
				isNdcMember: true,
				
			}));
		} else {
			setData((prevData) => ({
				...prevData,
				[name]: value,
				isNdcMember: false,
			}));
		} 
	};

	

	const handleMaritalStatus = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		if (value === "1") {
			setData((prevData) => ({
				...prevData,
				[name]: value,
			}));
		} else if (value === "2") {
			setData((prevData) => ({
				...prevData,
				[name]: value,
			}));
		} else if (value === "3") {
			setData((prevData) => ({
				...prevData,
				[name]: value,
			}));
		} else if (value === "4") {
			setData((prevData) => ({
				...prevData,
				[name]: value,
			}));
		} else if (value === "5") {
			setData((prevData) => ({
				...prevData,
				[name]: value,
			}));
		} else {
			setData((prevData) => ({
				...prevData,
				[name]: value,
			}));
		}
	};


	const checkMobileNumberValidity = (e, countryData) => {
		const dialCode = countryData.dialCode;
		const formatteddialCode = "+(" + dialCode + ")";
		const value = e.target.value.replaceAll(
			"+" + dialCode,
			formatteddialCode
		);
		const format = countryData.format.replaceAll(" ", "");

		if (
			value.startsWith(formatteddialCode) ||
			formatteddialCode.startsWith(formatteddialCode)
		) {
			if (value?.length >= format?.length) {
				// if (!isPossiblePhoneNumber(String(value))) {
				// 	toast.error(
				// 		`Invalid ${countryData.name} phone number . Please check and try again `,
				// 		{
				// 			duration: 5000,
				// 			className: "toast-message",
				// 		}
				// 	);
				// 	setData((prevData) => ({
				// 		...prevData,
				// 		isValidInput: false,
				// 	}));
				// 	return false;
				// } else {
				// 	setData((prevData) => ({
				// 		...prevData,
				// 		isValidInput: true,
				// 	}));
				// 	return true;
				// }
			}
			if (value?.length < format?.length) {
				// if (!isPossiblePhoneNumber(String(value))) {
				// 	toast.error(
				// 		`Invalid ${countryData.name} phone number . Please check and try again `,
				// 		{
				// 			duration: 5000,
				// 			className: "toast-message",
				// 		}
				// 	);
				// 	setData((prevData) => ({
				// 		...prevData,
				// 		isValidInput: true,
				// 	}));
				// 	return false;
				// }
			}
		}
	};

	const handleMobileNumberInput = (value, countryObj, e, formattedValue) => {
		const name = e.target.name;
		let mobileNumber = value.replaceAll(" ", "");

		if (mobileNumber.substring(4, 0) === "2330") {
			mobileNumber = mobileNumber.replace("0", "");
		}
		setData((prevData) => ({
			...prevData,
			country: countryObj?.countryCode,
			[name]: mobileNumber.replaceAll(" ", ""),
		}));
	};

	const validateEmailAddress = (e) => {
		const value = e.target.value;
		const checkEmail =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (!checkEmail.test(value)) {
			toast.error("Invalid email address. Correct it and try again", {
				duration: 5000,
				className: "toast-message",
			});
			setData((prevData) => ({
				...prevData,
				isValidInput: false,
			}));

			emailInputRef.current.focus();
			return false;
		} else {
			setData((prevData) => ({
				...prevData,
				isValidInput: true,
			}));
			return true;
		}
	};

	const handlePhoto = (e) => {
		let file = e.target.files[0];
		const name = e.target.name;
		if (file) {
			if (maxSelectedImage(e) && checkMimeType(e) && checkFileSize(e)) {
				setData((prevData) => ({
					...prevData,
					[name]: file,
					personalProfilePicture: URL.createObjectURL(
						e.target.files[0]
					),
				}));
			}
		}
	};

	const maxSelectedImage = (e) => {
		let file = e.target.files[0];
		if (file.length > 1) {
			const msg = "Only 1 images can be uploaded at a time";
			e.target.value = null; // discard selected file
			toast.error(msg);
			return false;
		} else {
			return true;
		}
	};
	const checkMimeType = (e) => {
		// get file object
		let file = e.target.files[0];
		let err = [];
		const types = [
			"image/jpg",
			"image/jpeg",
			"image/png",
			"image/gif",
			"image/svc",
		];
		for (var i = 0; i < file.length; i++) {
			// eslint-disable-next-line
			if (types.every((type) => file[i].type !== type)) {
				err[i] = file[i].type + " is not a supported format\n";
			}
		}
		for (var x = 0; x < err.length; x++) {
			e.target.value = null;
			toast.error(err[x]);
		}
		return true;
	};
	const checkFileSize = (e) => {
		let file = e.target.files[0];
		let size = 2000000;
		let err = [];
		for (var i = 0; i < file.length; i++) {
			if (file[i].size > size) {
				err[i] =
					file[i].type + " is too large. Please pick a small image\n";
			}
		}
		for (var x = 0; x < err.length; x++) {
			e.target.value = null;
			toast.error(err[x]);
		}
		return true;
	};

	const handleDragOver = (event) => {
		event.preventDefault();
	};

	const handleOnDrop = (event) => {
		//prevent the browser from opening the image
		event.preventDefault();
		event.stopPropagation();

		//let's grab the image file
		let imageFile = event.dataTransfer.files[0];
		// handleSignature(imageFile);
	};

	
	const handleChange = (e) => {
		const type = e.target.type;
		const name = e.target.name;
		const value = type === "checkbox" ? e.target.value : e.target.value;

	
		setData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const {
		personalMiddleName,
		membershipNdcMembershipNumber,
		...requiredInputs
	} = data;


	// const canSubmit = [...Object.values(requiredInputs)].every(Boolean) && page === Object.keys(title).length - 1

	
	// 	[...Object.values(requiredInputs)].every(Boolean) &&
	// 		page === Object.keys(corporateTitle).length - 1
	// );

	const canSubmit =
		page === Object.keys(registrationForms.memberRegistration).length - 1;
	// canSubmit = [...Object.values(requiredInputs)].every(Boolean) && page === Object.keys(individualTitle).length - 1

	
	// MEMBERSHIP STATUS
	const canNextPage0 = Object.keys(data)
		.filter((key) => key.startsWith("membership") &&
				key !== "membershipNdcMembershipNumber"
		)
		.map((key) => data[key])
		.every(Boolean);

	//  PERSONAL INFORMATION
	const canNextPage1 = Object.keys(data)
		.filter(
			(key) =>
				key.startsWith("personal") &&
			key !== "personalMiddleName" )
		.map((key) => data[key])
		.every(Boolean);

	// CONTACT INFORMATION
	const canNextPage2 = Object.keys(data)
		.filter((key) => key.startsWith("contact"))
		.map((key) => data[key])
		.every(Boolean);

	// REGION & CONSTITUENCY
	const canNextPage3 = Object.keys(data)
		.filter(
			(key) =>
				key.startsWith("regions") &&
				key !== "regionsBranchCode" &&
				key !== "regionsBranchName" 
		)
		.map((key) => data[key])
		.every(Boolean);

	// EDUCATION BACKGROUND
	const canNextPage4 = Object.keys(data)
		.filter((key) => key.startsWith("education"))
		.map((key) => data[key])
		.every(Boolean);
	
	// PROFESSION & OCCUPATION
	const canNextPage5 = Object.keys(data)
		.filter((key) => key.startsWith("profession"))
		.map((key) => data[key])
		.every(Boolean);

	// CONFIRMATION
	const canNextPage6 = Object.keys(data)
		.filter((key) => key.startsWith("confirm"))
		.map((key) => data[key])
		.every(Boolean);


	const disableNext =
		page === Object.keys(registrationForms.memberRegistration).length - 1 ||
		(page === 0 && !canNextPage0) ||
		(page === 1 && !canNextPage1) ||
		(page === 2 && !canNextPage2) ||
		(page === 3 && !canNextPage3) ||
		(page === 4 && !canNextPage4) ||
		(page === 5 && !canNextPage5) ||
		(page === 6 && !canNextPage6) 
	
		

	const disablePrev = page === 0;
	const prevHide = page === 0 && "remove-button";

	const nextHide =
		page === Object.keys(registrationForms.memberRegistration).length - 1 &&
		"remove-button";
	const submitHide =
		page !== Object.keys(registrationForms.memberRegistration).length - 1 &&
		"remove-button";

	return (
		<RegistrationContext.Provider
			value={{
				registrationForms,
				page,
				setPage,
				data,
				setData,
				canSubmit,
				regularData,
				handleMembershipStatus,
				checkMobileNumberValidity,
				handleMobileNumberInput,
				handleChange,
				handlePhoto,
				handleMaritalStatus,
				handleDragOver,
				handleOnDrop,
				validateEmailAddress,
				inputStart,
				emailInputRef,
				disablePrev,
				disableNext,
				prevHide,
				nextHide,
				submitHide,
			}}
		>
			<Toaster toastOptions={{ position: "top-center" }} />
			{children}
		</RegistrationContext.Provider>
	);
};

export default RegistrationContext;
